import { useEffect, useState } from 'react';

import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';
import type { CosmosData } from '@toolproof-core/visualization/derivation/_contract/derivation';

import type { SpaceAdapterDescriptor } from '@/_contract/types';

export function useSupplementalCosmosData<
	TResourceTypeHandle extends ResourceTypeHandle,
	TCosmosData extends CosmosData<TResourceTypeHandle>,
	TConfig,
	TRuntimeState,
>(descriptor: SpaceAdapterDescriptor<TResourceTypeHandle, TCosmosData, TConfig, TRuntimeState>) {
	const [result, setResult] = useState<{
		descriptor: typeof descriptor;
		data?: Partial<TCosmosData>;
		error?: Error;
	}>();
	useEffect(() => {
		const load = descriptor.loadSupplementalCosmosData;
		if (!load) return;
		const controller = new AbortController();
		void load(descriptor.baseDescriptor.defaultConfig, controller.signal).then((data) => {
			if (!controller.signal.aborted) setResult({ descriptor, data });
		}).catch((error: unknown) => {
			if (controller.signal.aborted) return;
			const failure = error instanceof Error ? error : new Error(String(error));
			console.error('[NativeAdapterDriver] Adapter data load failed:', failure);
			setResult({ descriptor, error: failure });
		});
		return () => controller.abort();
	}, [descriptor]);
	return result;
}
